module.exports = __webpack_public_path__ + "img/BloodyMess.5edee42c.png";